jQuery(document).ready(function ($) {
    if ($(".block-history").length) {
        function updateButtons(slick, currentSlide) {
            let prevButton = $('.slick-prev');
            let nextButton = $('.slick-next');

            prevButton.removeClass('disabled');
            nextButton.removeClass('disabled');

            if (currentSlide === 0) {
                prevButton.addClass('disabled');
            }

            if (currentSlide === slick.slideCount - 1) {
                nextButton.addClass('disabled');
            }
        }

        $('.js-history-numbers').slick({
                dots: false,
                arrows: true,
                infinite: false,
                slidesToShow: 6,
                slidesToScroll: 1,
                initialSlide: 0,
                focusOnSelect: true,
                touchMove: true,
                swipeToSlide: true,
                accessibility: true,
                asNavFor: '.js-numbers-description',

                responsive: [
                    {
                        breakpoint: 1240,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 860,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 570,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                ]
            }
        );

        $('.js-numbers-description').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.js-history-numbers',
            dots: false,
            arrows: false,        
            focusOnSelect: true,
            infinite: false,
        });

        $('.js-history-numbers').on('afterChange', function (event, slick, currentSlide) {
            updateButtons(slick, currentSlide);
        });

        $(window).on('resize', function() {
            $('.js-numbers-description').slick('refresh');
        });
    }
})